// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__qsYNP","title":"AfterFrontImage_title__3TEtQ"};